
$( document ).ready(function() {
    slidein.init();

    window.addEventListener("keyup", (ev) => {
        if (ev.key === 'Escape' && slidein.isOpen) {
            slidein.close();
        }
    });
});

var slidein = {
    bodyEl: null,
    slideinEl: null,
    slideinContentEl: null,
    slideinScrollerEl: null,
    slideinResizerEl: null,
    contentEl: null,
    slideinId: null,
    headerBoxEl: null,
    footerBoxEl: null,
    forceOverlay: false,
    isOpen: false,
    isMobil: false, // <= md

    init: function() {
        this.contentEl = $('.maingrid');
        this.slideinEl = $('#slidein');
        this.bodyEl = $('body');
        this.forceOverlay = this.bodyEl.is('.bauprogramm');
        $(window).resize(function() {
            var wasMobil = slidein.isMobil;
            slidein.isMobil = slidein.bodyEl.width() < 992;
            if (slidein.isOpen) {
                if (slidein.isMobil && !wasMobil) {
                    slidein.switchMobileView();
                } else if (wasMobil && !slidein.isMobil) {
                    slidein.switchMobileView();
                }
            }
        }).resize();

        this.slideinContentEl = this.slideinEl.find('.slidein-box');
        this.slideinScrollerEl = this.slideinContentEl.find('.slidein-content');
        this.slideinResizerEl = this.slideinEl.find('.resizer');
        this.slideinEl.resizable({
            handle: this.slideinResizerEl,
            handles: 'w',
            start: function() {
                slidein.slideinEl.css({'opacity': 0.6});
            },
            stop: function() {
                var width = parseInt(slidein.slideinEl.width());
                connection.setUserOption('slidein-width', width);
                slidein.slideinEl.css({ right: 0, left: '' });
                slidein.slideinEl.css({'opacity': 1});
                slidein.contentEl.css({'right': width});
                $(slidein).trigger('onResized');
            },
            resize: function() {
                var width = parseInt(slidein.slideinEl.width());
                slidein.slideinContentEl.width(width);
                slidein.slideinEl.css({
                    right: 0,
                    left: ''
                });
            }
        });
    },

    openUrl: function(url, onSuccess, options) {
        options = options || {};
        if (options.linkEl && options.linkEl.is('.dropdown-item')) {
            options.linkEl.closest('.btn-group.show')
                .find('.dropdown-toggle')
                .dropdown('toggle');
        }
        $('.header-expander .btn-group.show .dropdown-toggle').dropdown('toggle');
        if (!slidein.isOpen) {
            slidein.isOpen = true;
            if (options && options.linkEl) {
                options.linkEl.addClass('slidein-active');
            }
            // if (slidein.forceOverlay || (options.overlay && options.overlay === true)) {
            //     slidein.slideinEl.addClass('absolute').css({ top: 0 }); // $('header').height()
            // } else {
            //     slidein.slideinEl.removeClass('absolute').css({ top: 0 });
            // }
            slidein.bodyEl.addClass('slidein-open');
            if (!slidein.isMobil) {
                var width = connection.getUserOption('slidein-width') || 650;
                slidein.slideinEl.css('width', width);
                slidein.loadSlideIn(url, onSuccess, options);
                // setTimeout(() => {
                // }, 600);
                /*slidein.slideinEl.animate({
                    width: width,
                }, {
                    duration: 200,
                    easing: 'easeInSine',
                    complete: function () {
                        slidein.loadSlideIn(url, onSuccess, options);
                    },
                });*/
            } else {
                slidein.loadSlideIn(url, onSuccess, options);
            }
            if (slidein.isMobil) {
                slidein.switchMobileView();
            }
            $(slidein).trigger('onOpen', options);
        } else {
            $(slidein).trigger('onClose');
            setTimeout(function() {
                slidein.loadSlideIn(url, onSuccess, options);
            }, 200);
        }
    },

    switchMobileView: function() {
        if (!slidein.isMobil) {
            var width = connection.getUserOption('slidein-width') || 650;
            slidein.slideinContentEl.css({ width: width + "px", right: 0 });
            slidein.slideinEl.css({ width: width + "px" });
            slidein.contentEl.css({ right: width+"px", top: 0 });
            slidein.bodyEl.removeClass('modal-open');
        } else {
            slidein.slideinContentEl.css({ width: "100%", right: 0 });
            slidein.slideinEl.css({
                width: "calc(100% - 20px)",
                top: slidein.bodyEl.scrollTop()
            }).show();
            slidein.bodyEl.addClass('modal-open');
        }
    },

    loadSlideIn: function(url, onSuccess, options) {
        options = options || {};
        $('.dropdown-menu.show').removeClass('show');
        $(slidein).trigger('onOpen', options);
        slidein.slideinContentEl.html('');
        slidein.slideinContentEl.startProcess();
        if (url !== '') {
            connection.getHtmlPart(url, {
                timeout: options.timeout || 30000,
                onSuccess: function (data) {
                    slidein.slideinContentEl.html(data);
                    if (slidein.slideinContentEl.find('.slidein-header').length === 0) {
                        var errorHtml = $('<div class="slidein-header d-flex flex-column bg-danger">' +
                            '  <div class="d-flex">' +
                            '    Fehler...' +
                            '    <div class="close linkify ml-auto align-self-start">×</div>' +
                            '  </div>' +
                            '</div>' +
                            '<div class="slidein-content">'+data+'</div>');
                        slidein.slideinContentEl.html(errorHtml);
                    }
                    slidein.initSlideinContent(options);
                    if (onSuccess != null) onSuccess(slidein.slideinContentEl);
                },
                onError: function (err) {
                    var errorHtml = $('<div class="slidein-header d-flex flex-column bg-danger">' +
                        '  <div class="d-flex">' +
                        '    Fehler...' +
                        '    <div class="close linkify ml-auto align-self-start">×</div>' +
                        '  </div>' +
                        '</div>' +
                        '<div class="slidein-content"></div>');
                    debugger;
                    slidein.slideinContentEl.html(errorHtml);
                    slidein.initSlideinContent(options);
                },
                onComplete: function () {
                    slidein.slideinContentEl.endProcess();
                }
            });
        } else if (options.contentElement) {
            slidein.slideinContentEl.html(options.contentElement.html());
            slidein.initSlideinContent(options);
            if (onSuccess != null) onSuccess(slidein.slideinContentEl);
        }
    },

    initSlideinContent: function(options) {
        slidein.slideinScrollerEl = slidein.slideinContentEl.find('.slidein-content');
        slidein.slideinId = slidein.slideinEl.find('[data-slidein-id]').attr('data-slidein-id');
        slidein.headerBoxEl = slidein.slideinEl.find('.slidein-header');
        slidein.footerBoxEl = slidein.slideinEl.find('.slidein-footer');
        slidein.slideinContentEl.find('#slidein-trigger').trigger('opened');
        slidein.headerBoxEl.find('.close').click(function () {
            slidein.close();
        });
        if (options.backbutton) {
            slidein.headerBoxEl.find('h1').prepend('<span data-slidein="' + options.backbutton + '" class="px-2 py-1 mr-2 linkify"><i class="fa fa-chevron-left"></i></span>');
        }
        slidein.initTabs(options);
        slidein.initTabsWizzard();
        slidein.initFormSubmit();
        onContentReady(slidein.slideinEl);

        $(slidein).trigger('onOpened', {container: slidein.slideinEl});
        $(slidein).trigger('onResized');
    },

    close: function() {
        if (slidein.isOpen) {
            var focusField = $(slidein.slideinEl).find(':focus');
            focusField.trigger('change');

            $(slidein).trigger('onClose');
            $('.slidein-active').removeClass('slidein-active');
            slidein.bodyEl.removeClass('modal-open').removeClass('slidein-open');
            setTimeout(() => {
                slidein.slideinContentEl.html('');
                slidein.isOpen = false;
                $(slidein).trigger('onClosed');
                $(slidein).trigger('onResized');
            }, 600);
            slidein.contentEl.css({'right': 0});

            slidein.tabContainerEl = null;
            slidein.tabContentEls = null;
            slidein.tabbarButtonEls = null;
            slidein.tabCurrentTabEl = null;
        }
    },

    isWizzard: false,
    tabContainerEl: null,
    tabContentEls: null,
    tabFooterEls: null,
    tabbarButtonEls: null,
    tabCurrentTabEl: null,
    wizzardButtons: {
        saveMode: 'end',
        save: null,
        next: null,
        previous: null,
    },
    tabCurrentIndex: 0,
    tabLastIndex: 0,
    initTabs: function(options) {
        slidein.isWizzard = false;
        slidein.tabContainerEl = slidein.slideinContentEl.find('.slidein-tabs');
        slidein.tabContentEls = slidein.slideinContentEl.find('.slidein-tabs .slidein-tab');
        slidein.tabLastIndex = slidein.tabContentEls.length - 1;
        if (slidein.tabContentEls.length === 0) return;
        //
        slidein.tabFooterEls = slidein.slideinContentEl.find('.slidein-footer > div');
        slidein.tabbarButtonEls = slidein.slideinContentEl.find('#slidein-tabbar [data-tabslidein]');
        slidein.wizzardButtons.save = slidein.slideinContentEl.find('[type="submit"]');
        slidein.wizzardButtons.next = slidein.slideinContentEl.find('[data-wizzard-btn="next"]');
        slidein.wizzardButtons.previous = slidein.slideinContentEl.find('[data-wizzard-btn="back"]');

        slidein.showTab(0);

        slidein.slideinContentEl.find('#slidein-tabbar').find('[data-tabslidein]').click(function() {
            var me = $(this);
            // hide/show tab content
            var index = slidein.tabbarButtonEls.index(me);
            slidein.showTab(index);
        });
        if (options.linkEl && options.linkEl.attr('data-sidein-tab')) {
            slidein.slideinContentEl.find('#slidein-tabbar [data-tabslidein="'+options.linkEl.attr('data-sidein-tab')+'"]').trigger('click');
        }
        if (options.openTab) {
            slidein.slideinContentEl.find('#slidein-tabbar [data-tabslidein="'+options.openTab+'"]').trigger('click');
        }
    },

    showTab: function(index) {
        slidein.tabCurrentIndex = index;

        var oldTabContent = slidein.tabContentEls.filter('.show');
        if (oldTabContent.length) {
            $(slidein.tabContainerEl).trigger('onTabLeave', [oldTabContent]);
        }

        oldTabContent.removeClass('show');
        slidein.tabCurrentTabEl = $(slidein.tabContentEls[slidein.tabCurrentIndex]);
        slidein.tabCurrentTabEl.addClass('show');
        slidein.tabCurrentTabEl.trigger('onTabEnter');
        slidein.slideinScrollerEl.animate({
            scrollTop: 0
        }, 200);
        // buttons active state
        var activeButton = $(slidein.tabbarButtonEls[slidein.tabCurrentIndex]);
        slidein.tabbarButtonEls.removeClass('active');
        activeButton.addClass('active');
        // footer
        if (activeButton.length > 0) {
            var targetFooter = slidein.tabFooterEls.filter('.' + activeButton.attr('data-tabslidein').replace("dialog", "footer"));
            if (targetFooter.length === 1) {
                slidein.tabFooterEls.addClass('d-none');
                targetFooter.removeClass('d-none');
            }
        }

        if (slidein.isWizzard && slidein.wizzardButtons.saveMode === "end") {
            if (slidein.tabCurrentIndex === slidein.tabLastIndex) {
                slidein.wizzardButtons.save.removeClass('d-none');
            } else {
                slidein.wizzardButtons.save.addClass('d-none');
            }
        }
        if (slidein.isWizzard) {
            slidein.wizzardButtons.previous.prop('disabled', slidein.tabCurrentIndex === 0);
            if (slidein.tabCurrentIndex === slidein.tabLastIndex) {
                slidein.wizzardButtons.next.addClass('d-none');
                // slidein.wizzardButtons.next.prop('disabled', slidein.tabCurrentIndex === slidein.tabLastIndex);
            } else {
                slidein.wizzardButtons.next.removeClass('d-none');
            }
        }
    },

    isLastTabVisible: function() {
        return slidein.tabCurrentIndex >= slidein.tabLastIndex;
    },

    showNextTab: function() {
        if (slidein.tabCurrentIndex < slidein.tabLastIndex) {
            // validate step
            var isValid = true;
            var errors = [];
            slidein.tabCurrentTabEl.find('.is-invalid').each(function() {
                isValid = false;
            });
            slidein.tabCurrentTabEl.find('[data-required]').each(function() {
                var me = $(this);
                if (me.val().trim() == "" && me.attr('name') !== "") {
                    isValid = false;
                    errors.push({
                        field: me.attr('name'),
                        message: 'Feld darf nicht leer sein.'
                    });
                }
            });
            connection.addFormErrors(slidein.tabCurrentTabEl, {
                errors: errors
            });

            if (isValid) {
                slidein.showTab(slidein.tabCurrentIndex + 1);
            } else {
                messaging.showGlobalMessage('error', 'Fehler', 'Behebe zuerst die Fehler in diesem Schritt.');
                var $container = slidein.slideinScrollerEl;
                var $scrollTo = $(slidein.slideinScrollerEl.find('.is-invalid')[0]);
                $container.scrollTop(
                    $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                );
                $container.animate({
                    scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                }, 500);
            }
        }
    },

    showPreviousTab: function() {
        if (slidein.tabCurrentIndex > 0) {
            slidein.showTab(slidein.tabCurrentIndex - 1);
        }
    },

    initFormSubmit: function() {
    },

    initTabsWizzard: function() {
        slidein.isWizzard = false;
        var wizzardForm = slidein.slideinContentEl.find('[data-wizard]');
        if (wizzardForm.length === 1) {
            slidein.isWizzard = true;
            slidein.wizzardButtons.previous.prop('disabled', slidein.tabCurrentIndex === 0);
            slidein.wizzardButtons.next.prop('disabled', slidein.tabCurrentIndex === slidein.tabLastIndex);
            slidein.wizzardButtons.saveMode = wizzardForm.attr('data-wizard-save') || "end";

            slidein.wizzardButtons.previous.click(function() {
                slidein.showPreviousTab();
            });
            slidein.wizzardButtons.next.click(function() {
                slidein.showNextTab();
            });

            if (slidein.wizzardButtons.saveMode === "end") {
                slidein.wizzardButtons.save.addClass('d-none');
                // slidein.wizzardButtons.save.prop('disabled', true);
                slidein.wizzardButtons.save.click(function() {
                    if (slidein.tabCurrentIndex === slidein.tabLastIndex) {
                        wizzardForm.submit();
                    } else {
                        slidein.showNextTab();
                    }
                });
            } else {
                slidein.wizzardButtons.save.on('click', function() { wizzardForm.submit(); });
            }

            wizzardForm.on('submit', function() {
                connection.saveForm(wizzardForm, null, {
                    disableTaskError: true,
                    messageTimeout: 30000,
                    onSuccess: function(data) {
                        wizzardForm.trigger('submitSuccess', data);
                    },
                    onComplete: function(data) {
                        wizzardForm.trigger('submitComplete', data);
                    },
                    onError: function(data) {
                        debugger;
                    },
                    onErrorsAppended: function(data) {
                        debugger;
                        // go to error tab
                        slidein.showError();
                    },
                });
                return false;
            });


        }
    },

    addGeneralErrors: function(jsonData) {
        slidein.slideinScrollerEl.find('[data-global-error]').remove();
        var globalErrors = [];
        $.each(jsonData.errors || {}, function(index, item) {
            if (item.field.indexOf('general') === 0) {
                globalErrors.push(item.message);
            }
        });
        if (globalErrors.length > 0) {
            var errorBox = $('<div data-global-error class="bg-danger text-white stretch-box mb-2">' +
                '  <div class="d-flex">Fehler <i class="ml-auto fa fa-fw linkify close-error">×</i></div>' +
                '  <ul><li>' + globalErrors.join('</li><li>') + '</li></ul>' +
                '</div>');
            slidein.slideinScrollerEl.prepend(errorBox);
            errorBox.find('.close-error').click(function() {
                $(this).closest('[data-global-error]').remove();
            });
        }
    },

    showError: function() {
        debugger;
        var errorField = slidein.slideinContentEl.find('.is-invalid').first();
        if (errorField.length > 0) {
            var tab = errorField.closest('.slidein-tab');
            var index = slidein.tabContentEls.index(tab);
            slidein.showTab(index);
        }
    },

    resize: function() {
    }

};

window.slidein = slidein;
